// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__Z5EpN","container":"Modal_container__ReJmX","title":"Modal_title__jmP4d","icon":"Modal_icon__vr4Jc","btn":"Modal_btn__Zxkgv"};